import PropTypes from 'prop-types';
import { VISTAS } from '../../features/tickets';

// Bandejas = grupos reales del backend (objetos {id,nombre}). Vistas = presets
// de filtros. Sin contadores: con paginacion server-side no hay set completo.
const TicketsRail = ({ grupos, nav, onSelect }) => {
  const esActivo = (type, val) => nav.type === type && String(nav.val) === String(val);

  return (
    <nav className="tickets-rail" aria-label="Bandejas y vistas">
      <div className="tickets-rail__group">
        <p className="tickets-rail__caption">Bandejas</p>
        <ul className="tickets-rail__list">
          {grupos.map((grupo) => {
            const activo = esActivo('grupo', grupo.id);
            return (
              <li key={grupo.id}>
                <button
                  type="button"
                  className={`tickets-rail__item${activo ? ' is-active' : ''}`}
                  aria-current={activo ? 'true' : undefined}
                  onClick={() => onSelect({ type: 'grupo', val: grupo.id })}
                >
                  <span className="tickets-rail__label">{grupo.nombre}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="tickets-rail__group">
        <p className="tickets-rail__caption">Vistas</p>
        <ul className="tickets-rail__list">
          {VISTAS.map((vista) => {
            const activo = esActivo('view', vista.id);
            return (
              <li key={vista.id}>
                <button
                  type="button"
                  className={`tickets-rail__item${activo ? ' is-active' : ''}`}
                  aria-current={activo ? 'true' : undefined}
                  onClick={() => onSelect({ type: 'view', val: vista.id })}
                >
                  <span className="tickets-rail__label">{vista.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="tickets-rail__group">
        <p className="tickets-rail__caption">Herramientas</p>
        <ul className="tickets-rail__list">
          <li>
            <button
              type="button"
              className={`tickets-rail__item${nav.type === 'informe' ? ' is-active' : ''}`}
              aria-current={nav.type === 'informe' ? 'true' : undefined}
              onClick={() => onSelect({ type: 'informe', val: 'actividad' })}
            >
              <span className="tickets-rail__label">Actividad de tiques</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`tickets-rail__item${nav.type === 'respuestas' ? ' is-active' : ''}`}
              aria-current={nav.type === 'respuestas' ? 'true' : undefined}
              onClick={() => onSelect({ type: 'respuestas', val: 'gestion' })}
            >
              <span className="tickets-rail__label">Respuestas guardadas</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`tickets-rail__item${nav.type === 'bloqueos' ? ' is-active' : ''}`}
              aria-current={nav.type === 'bloqueos' ? 'true' : undefined}
              onClick={() => onSelect({ type: 'bloqueos', val: 'gestion' })}
            >
              <span className="tickets-rail__label">Correos bloqueados</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

TicketsRail.propTypes = {
  grupos: PropTypes.arrayOf(PropTypes.object),
  nav: PropTypes.shape({
    type: PropTypes.oneOf(['grupo', 'view', 'informe', 'respuestas', 'bloqueos']).isRequired,
    val: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

TicketsRail.defaultProps = {
  grupos: [],
};

export default TicketsRail;
